module.exports = __webpack_public_path__ + "static/media/ffigueras2.2bc77b0c.jpg";